module.exports = __webpack_public_path__ + "static/media/2@3x.807a58b2.png";